import { SplashScreen } from 'src/components/loading-screen';
import { ModuleEntitlementsContext } from './module-entitlements-context';

// ----------------------------------------------------------------------

type Props = {
    children: React.ReactNode;
};

export function ModuleEntitlementsConsumer({ children }: Props) {
    return (
        <ModuleEntitlementsContext.Consumer>
            {(entitlements) => (entitlements.loaded ? children : <SplashScreen />)}
        </ModuleEntitlementsContext.Consumer>
    );
}
